// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectsSection-module--root--30WpR"};